import { render, staticRenderFns } from "./ChildrenSurvey.vue?vue&type=template&id=e0024b52"
import script from "./ChildrenSurvey.vue?vue&type=script&lang=ts"
export * from "./ChildrenSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports